(function() {
  "use strict";

  angular
    .module("app")
    .controller("DomainYearPickerController", [
      "$scope",
      "$location",
      "CommunitiesService",
      "LoadingService",
      DomainYearPickerController
    ]);

  function DomainYearPickerController(
    $scope,
    $location,
    CommunitiesService,
    LoadingService
  ) {
    // This is a `$watch`er instead of a simple method so changes made by other controllers
    // will still trigger this API request. Primary use-case: when a user selects a domain
    // for the first time, `selectedYear` defaults to the most recent year, and we want to
    // immediately request and display the appropriate community data for that year.
    $scope.$watch("state.selectedYear", function() {
      $scope.yearPickerIsOpen = false;

      $location.search("year", $scope.state.selectedYear.id);
      // We pass this to `checkForUserSelections` to compare against the updated community
      // ranks, checking to see if we need to make any selection changes
      var oldCommunityRanks = $scope.state.communitiesByRank;

      var communityLoadingId = LoadingService.taskStart(
        $scope.$parent,
        "Loading Community Data"
      );

      CommunitiesService.getCommunityData(
        $scope.state.selectedDomain.id,
        $scope.state.selectedYear.id
      ).then(
        function(response) {
          LoadingService.taskEnd($scope.$parent, communityLoadingId);

          $scope.state.selectedCommunities.build(
            response.communityDistrictData,
            oldCommunityRanks
          );

          if (
            response.cityDemographics &&
            Object.keys(response.cityDemographics).length
          ) {
            $scope.state.citywideStats = response.cityDemographics;
          }

          // Now that we have all the community data we need, render that map
          $scope.rrMap.render();

          // When the indicator changes, the community data does too.
          // Re-style each community to display the proper ranking
          $scope.state.communityData.forEach(function(community, ind, arr) {
            $scope.rrMap.styleShape(community.fips);
          });
        },
        function(response) {
          console.warn("getCommunityData failed!");
        }
      );
    });

    $scope.dataLayerPush = function() {
      // Tracks use of the domain year selector dropdown on the "Risk Ranking" page
      dataLayer.push({
        event: "Domain Year Selector Clicks",
        eventCategory: "Interactive Clicks",
        eventAction: "Domain Year Selector|" + $scope.state.selectedYear.name,
        eventLabel: window.location.pathname
      });
    };
  }
})();
